<div class="mm-profile-learner-missing">
    <app-message-box class="mm-profile-learner-missing-message"
                     type="info"
                     [header]="'profileLearnerMissing.title' | translate"
                     [content]="'profileLearnerMissing.description' | translate">
    </app-message-box>
    <app-button type="primary" [action]="retry">
        {{ 'profileLearnerMissing.retry' | translate }}
    </app-button>
</div>
